import iconImg from "../../assets/Technical_Proposal_FDC__2_-removebg-preview.png"
import aiopsarc from "../../assets/Netraa AI Ops Achitecture.svg"

export function renderAiOverview () {
    return (
  <div className="space-y-12 overflow-hidden" >
        {/* Breadcrumb */}

<section
  className="border-b border-gray-200 dark:border-gray-800 pb-8 mb-10"
  id="introduction"
>
  <div className="inline-flex items-center px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-xs font-bold uppercase tracking-wider mb-4 border border-orange-200 dark:border-orange-800">
    Guide
  </div>

  {/* Title + Button Row */}
 <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
  {/* Heading */}
  <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight">
    <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
      Netraa AIOps: <br/>
    </span>
    <span className="text-4xl">From Reactive Monitoring to<br/></span>
    <span className="text-4xl bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600">
      Intelligent Narratives
    </span>
  </h1>

  {/* Image on the right */}
  <div className="p-1 rounded-xl flex items-center justify-center">
    <img
      src={iconImg}
      alt="Monitoring"
      className="w-16 h-16 lg:w-20 lg:h-20" // You can adjust the size
    />
  </div>
</div>

  <p className="text-xl text-text-muted dark:text-gray-400 leading-relaxed mb-8">
    Stop chasing alerts. Start solving problems. Netraa transforms millions of telemetry signals into coherent, actionable narratives using advanced causal AI. This documentation provides a comprehensive overview of the platform's core capabilities.  </p>
   <div className="flex flex-wrap gap-4">
              <button onClick={() => window.location.href = "https://cliqtest.com/book-a-demo"} className="px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-bold shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transform hover:-translate-y-1 transition-all">
              Book Demo
              </button>
            </div>
</section>
    <section className="scroll-mt-24 mb-20" id="architecture">
      <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
        <span className="p-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400">
          <span className="material-symbols-outlined">architecture</span>
        </span>
        Netraa AIOps Architecture
      </h2>

      <p className="text-base text-text-muted dark:text-gray-400 mb-8 leading-relaxed">
        The Netraa APM ecosystem is built on three core pillars designed for
        scale and reliability: <strong>Intelligent Agents</strong>, a{" "}
        <strong>High-Performance Processing Layer</strong>, and an{" "}
        <strong>Intuitive UI</strong>.
      </p>

      {/* diagram container */}
      <div className="w-full bg-gray-50 dark:bg-[#16181C] rounded-2xl border border-gray-200 dark:border-gray-800 p-2 lg:p-2 mb-10 overflow-hidden relative">
        <div className="relative z-10 flex flex-col items-center w-full">
          <img
            src={aiopsarc}
            className="w-[95%] max-w-none object-contain -mx-[10%]"
          />
        </div>
      </div>

    </section>
<section className="mb-24 scroll-mt-24" id="core-problem">
  <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
    <span className="material-symbols-outlined text-netraa-orange">crisis_alert</span>
    The Core Problem &amp; Solution
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
  {/* Problem Card */}
  <div className="glass-card p-6 flex flex-col h-full relative overflow-hidden group
                  bg-white/5 border rounded-xl border-gray-300/100 shadow-sm
                  dark:bg-glass-gradient dark:border-white/10 dark:shadow-glass">
    <div className="absolute -right-10 -top-10 w-24 h-24 bg-red-500/10 rounded-full blur-xl group-hover:bg-red-500/20 transition-all"></div>
    <div className="flex items-center gap-3 mb-3">
      <span className="text-red-500 text-sm font-bold uppercase tracking-wider">The Problem</span>
    </div>
    <h3 className="text-lg font-bold text-black dark:text-white mb-2">Alert Fatigue</h3>
    <p className="text-gray-400 dark:text-text-secondary text-sm leading-relaxed mb-4">
      Teams are drowning in dashboard noise, missing critical signals amidst thousands of false positives and disconnected tools.
    </p>
    <div className="mt-auto h-20 bg-black/5 dark:bg-black/20 rounded-lg border border-gray-200/20 dark:border-white/5 relative overflow-hidden p-2">
      <div className="flex gap-1 items-end h-full w-full justify-between px-1">
        <div className="w-1 bg-red-500/40 h-[80%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/60 h-[40%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/30 h-[90%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/80 h-[20%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/50 h-[60%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/40 h-[85%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/20 h-[30%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/70 h-[75%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/40 h-[50%] rounded-t-sm"></div>
        <div className="w-1 bg-red-500/60 h-[95%] rounded-t-sm"></div>
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-[10px] font-mono bg-white/80 dark:bg-black/80 px-2 py-0.5 rounded text-red-600 dark:text-red-400 border border-red-500/30">
          CRITICAL: 99+
        </span>
      </div>
    </div>
  </div>

  {/* Solution Card */}
  <div className="glass-card p-6 flex flex-col h-full relative overflow-hidden group
                  bg-white/5 border rounded-xl border-gray-300/100 shadow-sm
                  dark:bg-glass-gradient dark:border-white/10 dark:shadow-glass">
    <div className="absolute -right-10 -top-10 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-netraa-cyan/20 transition-all"></div>
    <div className="flex items-center gap-3 mb-3">
      <span className="text-cyan-500 text-sm font-bold uppercase tracking-wider">The Solution</span>
    </div>
    <h3 className="text-lg font-bold text-black dark:text-white mb-2">Contextual AI</h3>
    <p className="text-gray-400 dark:text-text-secondary text-sm leading-relaxed mb-4">
      Netraa correlates topology, logs, and metrics to pinpoint root cause instantly, not just symptoms.
    </p>
    <div className="mt-auto h-20 bg-black/5 dark:bg-black/20 rounded-lg border border-gray-200/20 dark:border-white/5 relative overflow-hidden flex items-center justify-center">
  {/* Connector background gradient */}
  <div className="absolute inset-0 bg-cyan-gradient opacity-20 dark:opacity-10"></div>

  {/* Dots and connecting lines */}
  <div className="flex items-center gap-1">
    {/* First dot */}
    <div className="w-1.5 h-1.5 rounded-full 
                    bg-cyan-700 dark:bg-netraa-cyan 
                    shadow-[0_0_5px_rgba(0,102,128,0.5)] dark:shadow-[0_0_10px_rgba(0,229,255,1)]">
    </div>

    {/* Connector line */}
    <div className="w-12 h-[1px] bg-cyan-400 dark:bg-netraa-cyan"></div>

    {/* Second dot */}
    <div className="w-1.5 h-1.5 rounded-full 
                    bg-cyan-700 dark:bg-netraa-cyan 
                    shadow-[0_0_5px_rgba(0,102,128,0.5)] dark:shadow-[0_0_10px_rgba(0,229,255,1)]">
    </div>

    {/* Connector line */}
    <div className="w-12 h-[1px] bg-cyan-400 dark:bg-netraa-cyan"></div>

    {/* Pulsing white dot at the end */}
    <div className="w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_5px_rgba(200,200,200,0.7)] dark:shadow-[0_0_15px_rgba(255,255,255,1)] animate-pulse"></div>
  </div>
</div>
  </div>

  {/* Impact Card */}
  <div className="glass-card p-6 flex flex-col h-full relative overflow-hidden group
                  bg-white/5 border rounded-xl border-gray-300/100 shadow-sm
                  dark:bg-glass-gradient dark:border-white/10 dark:shadow-glass">
    <div className="absolute -right-10 -top-10 w-24 h-24 bg-orange-500/10 rounded-full blur-xl group-hover:bg-orange-500/20 transition-all"></div>
    <div className="flex items-center gap-3 mb-3">
      <span className="text-orange-600 text-sm font-bold uppercase tracking-wider">The Impact</span>
    </div>
    <h3 className="text-lg font-bold text-black dark:text-white mb-2">Reduce MTTR</h3>
    <p className="text-gray-400 dark:text-text-secondary text-sm leading-relaxed mb-4">
      Reduce MTTR by 80%. Empower Level 1 engineers to solve Level 3 problems with automated runbooks.
    </p>
    <div className="mt-auto h-20 bg-black/5 dark:bg-black/20 rounded-lg border border-gray-200/20 dark:border-white/5 relative overflow-hidden flex items-end p-2">
      <svg className="w-full h-full" preserveAspectRatio="none" viewBox="0 0 100 40">
        <path
          d="M0 35 C 20 35, 30 10, 50 10 S 70 5, 100 2"
          fill="none"
          stroke="#FF5722"
          strokeWidth="2"
        />
        <path
          d="M0 35 C 20 35, 30 10, 50 10 S 70 5, 100 2 L 100 40 L 0 40 Z"
          fill="url(#gradient-orange)"
          opacity="0.2"
        />
        <defs>
          <linearGradient id="gradient-orange" x1="0%" x2="0%" y1="0%" y2="100%">
            <stop offset="0%" stopColor="#FF5722" stopOpacity="1" />
            <stop offset="100%" stopColor="#FF5722" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</div>
</section>
<section class="mb-24 scroll-mt-24 flex flex-col lg:flex-row items-center gap-10" id="observability-universe">
  {/* <!-- Text Content --> */}
<div class="flex-1 text-left">
  <h2 class="text-2xl lg:text-3xl font-bold mb-4">
    The Center of Your {""}
    <span class="text-netraa-cyan dark:text-cyan-500 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
      Observability Universe
    </span>
  </h2>
  <p class="text-gray-700 dark:text-gray-400 text-base mb-6 leading-relaxed">
    Netraa isn't just another tool. It's the intelligence layer that sits above your existing stack. We ingest data from everywhere—Datadog, Splunk, Prometheus, CloudWatch—and synthesize it into a single source of truth.
  </p>
  <ul class="space-y-3 inline-block text-left text-sm">
    <li class="flex items-center gap-3 text-gray-800 dark:text-white">
      <span class="material-symbols-outlined text-cyan-500 dark:text-cyan-400 text-base">check_circle</span>
      <span>Zero-touch agentless integration</span>
    </li>
    <li class="flex items-center gap-3 text-gray-800 dark:text-white">
      <span class="material-symbols-outlined text-cyan-500 dark:text-cyan-400 text-base">check_circle</span>
      <span>Unified data model for metrics, logs, &amp; traces</span>
    </li>
    <li class="flex items-center gap-3 text-gray-800 dark:text-white">
      <span class="material-symbols-outlined text-cyan-500 dark:text-cyan-400 text-base">check_circle</span>
      <span>Vendor-agnostic AI correlation</span>
    </li>
  </ul>
</div>
{/* Orbital Animation */}
<div className="flex-1 flex justify-center items-center py-6">
  <div className="orb-container relative w-[300px] h-[300px]">

    {/* Background Glow (visible in both modes) */}
    <div
      className="absolute top-1/4 left-1/3 -translate-x-1/2 -translate-y-1/2 
      w-40 h-40 rounded-full blur-3xl pointer-events-none
      bg-black/5 dark:bg-netraa-cyan/10"
    ></div>

    {/* Central Floating Orb */}
<div
  className="central-orb animate-float 
  bg-gradient-to-tr from-orange-100 to-orange-200
  dark:bg-black dark:bg-none"
>
  <img
    src={iconImg}
    alt="Floating Orb"
    className="w-16 h-16 object-contain"
  />
</div>

    {/* Inner Orbit Ring (Fast, CCW) */}
    <div
      className="orbit-ring w-[200px] h-[200px] absolute top-1/2 left-1/2 
      -translate-x-1/2 -translate-y-1/2 
      animate-[orbit_15s_linear_infinite_reverse] 
      border-black/30 dark:border-white/20 z-10"
    >
      <div
        className="orbit-item absolute -top-4 left-1/2 -translate-x-1/2 
        bg-black dark:bg-white/70 text-white dark:text-black"
        title="Datadog"
      >
        <span className="font-bold text-[8px]">DD</span>
      </div>

      <div
        className="orbit-item absolute -bottom-4 left-1/2 -translate-x-1/2 
        bg-black dark:bg-white/70 text-white dark:text-black"
        title="Splunk"
      >
        <span className="font-bold text-[8px]">SP</span>
      </div>
    </div>

    {/* Outer Orbit Ring (Slow, CW) */}
    <div
      className="orbit-ring w-[280px] h-[280px] absolute top-1/2 left-1/2 
      -translate-x-1/2 -translate-y-1/2 
      animate-[orbit_30s_linear_infinite] 
      border-black/30 dark:border-white/20 z-10"
    >
      <div
        className="orbit-item absolute top-1/2 -right-4 -translate-y-1/2 
        bg-black dark:bg-white/70 text-white dark:text-black"
        title="Prometheus"
      >
        <span className="font-bold text-[8px]">PR</span>
      </div>

      <div
        className="orbit-item absolute top-1/2 -left-4 -translate-y-1/2 
        bg-black dark:bg-white/70 text-white dark:text-black"
        title="AWS"
      >
        <span className="font-bold text-[8px]">AWS</span>
      </div>
    </div>

  </div>
</div>
</section>
<section className="mb-24 scroll-mt-24" id="ai-capabilities">
  <div className="flex items-center justify-between mb-8">
    <h2 className="text-2xl font-bold flex items-center gap-2">
      <span className="material-symbols-outlined text-blue-400 dark:text-cyan-500">
        auto_awesome
      </span>
      Platform Capabilities
    </h2>
  </div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

  {/* Universal Event Correlation Card */}
  <div
    className="
    col-span-1 md:col-span-2
    relative overflow-hidden rounded-2xl
    p-6 flex flex-col justify-between
    transition-all duration-500 group

    /* Glass Base */
    bg-gradient-to-br from-white/80 via-white/60 to-white/40
    dark:from-[#0b0f14]/80 dark:via-[#0b0f14]/60 dark:to-[#0b0f14]/40
    backdrop-blur-2xl

    /* Border */
    border border-gray-200/70 dark:border-white/10

    /* Premium Shadow */
    shadow-[0_10px_50px_rgba(0,0,0,0.08)]
    dark:shadow-[0_20px_80px_rgba(0,0,0,0.6)]

    hover:-translate-y-1
    hover:shadow-[0_20px_70px_rgba(0,0,0,0.12)]
    dark:hover:shadow-[0_30px_90px_rgba(0,0,0,0.8)]
    "
  >

    {/* Animated Gradient Glow (Top Right) */}
    <div
      className="
      absolute -top-20 -right-20 w-72 h-72
      bg-gradient-to-br from-blue-400/30 via-cyan-300/20 to-transparent
      dark:from-cyan-400/20 dark:via-blue-500/10
      rounded-full blur-3xl
      opacity-70 group-hover:opacity-100
      transition duration-700
      pointer-events-none"
    />

    {/* Subtle Border Shine */}
    <div className="absolute inset-0 rounded-2xl pointer-events-none border border-white/40 dark:border-white/5" />

    {/* Header */}
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="
          p-2.5 rounded-xl
          bg-gradient-to-br from-indigo-500 via-purple-500 to-blue-500
          shadow-lg shadow-indigo-500/20
          group-hover:scale-105 transition
        ">
          <span className="material-symbols-outlined text-white text-base">
            hub
          </span>
        </div>

        <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
          Universal Event Correlation
        </h3>
      </div>

      <p className="
        text-gray-600 dark:text-gray-400
        text-sm leading-relaxed mb-6
      ">
        Break down data silos across your entire enterprise stack. Netraa seamlessly
        ingests, normalizes, and correlates alerts from heterogeneous environments—
        including Datadog, Splunk, Dynatrace, and CloudWatch—into a single,
        unified operational timeline powered by intelligent correlation.
      </p>
    </div>

    {/* Premium Incident Console */}
    <div
      className="
      relative rounded-xl p-4 font-mono text-xs
      border
      bg-gradient-to-b from-gray-50/80 to-gray-100/60
      dark:from-black/80 dark:to-black/60
      border-gray-200/80 dark:border-white/10
      text-gray-800 dark:text-gray-300
      backdrop-blur-md
      shadow-inner
      overflow-hidden
      "
    >
      {/* Console Glow Line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-blue-400/70 to-transparent dark:via-cyan-400/70" />

      {/* Window Dots */}
      <div className="absolute top-2 right-3 flex gap-1">
        <div className="w-2 h-2 rounded-full bg-red-500 shadow-sm"></div>
        <div className="w-2 h-2 rounded-full bg-yellow-500 shadow-sm"></div>
        <div className="w-2 h-2 rounded-full bg-green-500 shadow-sm"></div>
      </div>

      <p className="text-blue-600 dark:text-cyan-400 mb-2">
        &gt; Ingesting telemetry streams across multi-cloud ecosystem...
      </p>

      <p className="opacity-80 mb-2">
        Normalizing concurrent alerts from [Datadog], [Splunk], and [SolarWinds]...
      </p>

      <p className="text-orange-600 dark:text-orange-400">
        Correlation complete: 42 redundant alert storms suppressed.  
        Result: 1 unified incident → 'Payment Gateway Timeout'
      </p>
    </div>

  </div>


    <div
  className="
  col-span-1 md:col-span-2
  relative overflow-hidden rounded-2xl
  p-6 flex flex-col justify-between
  transition-all duration-500 group

  /* Glass Base (same as first card) */
  bg-gradient-to-br from-white/80 via-white/60 to-white/40
  dark:from-[#0b0f14]/80 dark:via-[#0b0f14]/60 dark:to-[#0b0f14]/40
  backdrop-blur-2xl

  /* Border */
  border border-gray-200/70 dark:border-white/10

  /* Premium Shadow */
  shadow-[0_10px_50px_rgba(0,0,0,0.08)]
  dark:shadow-[0_20px_80px_rgba(0,0,0,0.6)]

  hover:-translate-y-1
  hover:shadow-[0_20px_70px_rgba(0,0,0,0.12)]
  dark:hover:shadow-[0_30px_90px_rgba(0,0,0,0.8)]
  "
>
  {/* Purple/Violet Glow (DIFFERENT COLOR FROM FIRST CARD) */}
  <div
    className="
    absolute -top-20 -right-20 w-72 h-72
    bg-gradient-to-br from-purple-400/50 via-violet-300/20 to-transparent
    dark:from-purple-500/20 dark:via-violet-500/10
    rounded-full blur-3xl
    opacity-70 group-hover:opacity-100
    transition duration-700
    pointer-events-none"
  />

  {/* Subtle Shine Border */}
  <div className="absolute inset-0 rounded-2xl pointer-events-none border border-white/40 dark:border-white/5" />

  {/* Content */}
  <div>
    <div className="flex items-center gap-3 mb-4">
      <div className="
        p-2.5 rounded-xl
        bg-gradient-to-br from-purple-500 via-violet-500 to-indigo-500
        shadow-lg shadow-purple-500/20
        group-hover:scale-105 transition
      ">
        <span className="material-symbols-outlined text-white text-base">
          chat_bubble
        </span>
      </div>

      <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
        GenAI Intelligence
      </h3>
    </div>

    <p className="
      text-gray-600 dark:text-gray-400
      text-sm leading-relaxed mb-6
    ">
      Forget cryptic error codes. Netraa generates human-readable narrative
      summaries of every incident, explaining exactly what broke, why it
      happened, and how to fix it with AI-driven contextual intelligence.
    </p>
  </div>

  {/* Premium AI Console Box */}
  <div
    className="
    relative rounded-xl p-4 font-mono text-xs
    border
    bg-gradient-to-b from-gray-50/80 to-gray-100/60
    dark:from-black/80 dark:to-black/60
    border-gray-200/80 dark:border-white/10
    text-gray-800 dark:text-gray-300
    backdrop-blur-md
    shadow-inner
    overflow-hidden
    "
  >
    {/* Top glow line (purple themed) */}
    <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-purple-400/70 to-transparent dark:via-violet-400/70" />

    {/* Window dots */}
    <div className="absolute top-2 right-3 flex gap-1">
      <div className="w-2 h-2 rounded-full bg-red-500"></div>
      <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
      <div className="w-2 h-2 rounded-full bg-green-500"></div>
    </div>

    <p className="text-purple-600 dark:text-violet-400 mb-2">
      &gt; Analysing Incident #4921...
    </p>

    <p className="opacity-80 mb-2">
      Root cause identified: High latency in 'Payment-Service' due to
      database lock contention and cascading retry storms.
    </p>

    <p className="text-orange-600 dark:text-orange-400">
      Recommendation: Rollback deployment v2.4.1 or increase connection pool
      size to stabilize service latency.
    </p>
  </div>
</div>

<div
  className="
  col-span-1 md:col-span-2
  relative overflow-hidden rounded-2xl
  p-6 flex flex-col justify-between
  transition-all duration-500 group

  /* Glass Base */
  bg-gradient-to-br from-white/80 via-white/60 to-white/40
  dark:from-[#0b0f14]/80 dark:via-[#0b0f14]/60 dark:to-[#0b0f14]/40
  backdrop-blur-2xl

  /* Border */
  border border-gray-200/70 dark:border-white/10

  /* Premium Shadow */
  shadow-[0_10px_50px_rgba(0,0,0,0.08)]
  dark:shadow-[0_20px_80px_rgba(0,0,0,0.6)]

  hover:-translate-y-1
  hover:shadow-[0_20px_70px_rgba(0,0,0,0.12)]
  dark:hover:shadow-[0_30px_90px_rgba(0,0,0,0.8)]
  "
>

  {/* Emerald Glow */}
  <div
    className="
    absolute -top-20 -right-20 w-72 h-72
    bg-gradient-to-br from-emerald-400/30 via-teal-300/20 to-transparent
    dark:from-emerald-500/20 dark:via-teal-500/10
    rounded-full blur-3xl
    opacity-70 group-hover:opacity-100
    transition duration-700
    pointer-events-none"
  />

  {/* Subtle Border Shine */}
  <div className="absolute inset-0 rounded-2xl pointer-events-none border border-white/40 dark:border-white/5" />

  {/* Content */}
  <div>
    <div className="flex items-center gap-3 mb-4">
      <div className="
        p-2.5 rounded-xl
        bg-gradient-to-br from-emerald-500 via-teal-500 to-green-500
        shadow-lg shadow-emerald-500/20
        group-hover:scale-105 transition
      ">
        <span className="material-symbols-outlined text-white text-base">
          auto_awesome
        </span>
      </div>

      <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
        RAG Docs Chatbot
      </h3>
    </div>

    <p className="
      text-gray-600 dark:text-gray-400
      text-sm leading-relaxed mb-6
    ">
      Documentation-Aware RAG Intelligence. Stop scrambling for fragmented
      runbooks during high-severity incidents. Netraa vectorizes your internal
      wikis and vendor manuals into a conversational knowledge engine —
      merging observability with knowledge management for instant,
      context-aware answers.
    </p>
  </div>

  {/* Knowledge Console */}
  <div
    className="
    relative rounded-xl p-4 font-mono text-xs
    border
    bg-gradient-to-b from-gray-50/80 to-gray-100/60
    dark:from-black/80 dark:to-black/60
    border-gray-200/80 dark:border-white/10
    text-gray-800 dark:text-gray-300
    backdrop-blur-md
    shadow-inner
    overflow-hidden
    "
  >
    {/* Top glow line */}
    <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-emerald-400/70 to-transparent dark:via-emerald-400/70" />

    {/* Window dots */}
    <div className="absolute top-2 right-3 flex gap-1">
      <div className="w-2 h-2 rounded-full bg-red-500"></div>
      <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
      <div className="w-2 h-2 rounded-full bg-green-500"></div>
    </div>

    <p className="text-emerald-600 dark:text-emerald-400 mb-2">
      &gt; Querying vectorized documentation...
    </p>

    <p className="opacity-80 mb-2">
      "What does Dynatrace recommend for this anomaly?"
      Retrieving relevant context from internal runbooks and vendor manuals...
    </p>

    <p className="text-orange-600 dark:text-orange-400">
      Actionable Advice: Increase 'max_connections' to 500 as per Configuration Wiki v2.4.
    </p>
  </div>

</div>


<div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl bg-white/20 dark:bg-black glass-gradient border border-gray/50 dark:border-white/20 p-6 flex flex-col justify-between shadow-glass transition-all duration-300 group">
      {/* Floating gradient circle */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200/20 dark:bg-cyan/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="p-1.5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
            <span className="material-symbols-outlined text-white text-sm">
              chat_bubble
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            Real-Time Anomaly Detection
          </h3>
        </div>
        <p className="text-gray-700 dark:text-gray-500 text-sm max-w-xl mb-4">
Catch the uncatchable. Netraa’s machine learning models instantly identify subtle outliers and metric spikes in real-time, allowing your team to detect and prevent incidents before they cascade into critical system failures.
        </p>
      </div>

      {/* Incident Box */}
      <div className="bg-gray-100/40 dark:bg-black rounded-xl p-3 border border-gray-200/30 dark:border-white/5 font-mono text-xs text-gray-700 dark:text-gray-300 relative">
        <div className="absolute top-2 right-2 flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
        </div>
        <p className="text-blue-500 dark:text-netraa-cyan mb-1">
          &gt; Monitoring baseline metrics for 'Inventory-API'...        </p>
        <p className="opacity-80">
          Anomaly Detected: Payload latency spiked to 450ms (Normal Baseline: 45ms).
        </p>
        <p className="text-orange-500 mt-1">
          Status: Early warning triggered. Intervening before SLA breach threshold is met.
        </p>
      </div>
    </div>



<div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl bg-white/20 dark:bg-black glass-gradient border border-gray/50 dark:border-white/20 p-6 flex flex-col justify-between shadow-glass transition-all duration-300 group">
      {/* Floating gradient circle */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200/20 dark:bg-cyan/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="p-1.5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
            <span className="material-symbols-outlined text-white text-sm">
              chat_bubble
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            Automated Topology Mapping
          </h3>
        </div>
        <p className="text-gray-700 dark:text-gray-500 text-sm max-w-xl mb-4">
          Gain absolute visibility into your architecture. Netraa AIOPS automatically discovers application components, maps complex cross-service dependencies in real-time, and identifies dormant entities that are quietly draining your cloud budget.
        </p>
      </div>

      {/* Incident Box */}
      <div className="bg-gray-100/40 dark:bg-black rounded-xl p-3 border border-gray-200/30 dark:border-white/5 font-mono text-xs text-gray-700 dark:text-gray-300 relative">
        <div className="absolute top-2 right-2 flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
        </div>
        <p className="text-blue-500 dark:text-netraa-cyan mb-1">
          &gt; Scanning environment architecture and entity connections...        </p>
        <p className="opacity-80">
          Dependencies mapped: 142 active microservices across 3 clusters.
Insight: Detected 4 dormant 'Legacy-Reporting' database instances.
        </p>
        <p className="text-orange-500 mt-1">
          Suggested action: Decommission entities to optimize infrastructure costs.
        </p>
      </div>
    </div>



<div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl bg-white/20 dark:bg-black glass-gradient border border-gray/50 dark:border-white/20 p-6 flex flex-col justify-between shadow-glass transition-all duration-300 group">
      {/* Floating gradient circle */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200/20 dark:bg-cyan/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="p-1.5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
            <span className="material-symbols-outlined text-white text-sm">
              chat_bubble
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            True Causal AI Root Cause Analysis
          </h3>
        </div>
        <p className="text-gray-700 dark:text-gray-500 text-sm max-w-xl mb-4">
        Eliminate the alert storms and false positives caused by basic correlation. By analyzing metrics, logs, traces, topology, and change events, Netraa's Causal AI constructs a precise diagnostic chain that mirrors human reasoning—clearly distinguishing the primary root cause from noisy downstream secondary symptoms.
        </p>
      </div>

      {/* Incident Box */}
      <div className="bg-gray-100/40 dark:bg-black rounded-xl p-3 border border-gray-200/30 dark:border-white/5 font-mono text-xs text-gray-700 dark:text-gray-300 relative">
        <div className="absolute top-2 right-2 flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
        </div>
        <p className="text-blue-500 dark:text-netraa-cyan mb-1">
          &gt; Constructing causal chain for 34 simultaneous failure events...        </p>
        <p className="opacity-80">
Analyzing distributed traces, metrics, and recent CI/CD deployment logs.
Filtered 33 downstream failures and secondary symptoms.
        </p>
        <p className="text-orange-500 mt-1">
          Primary Root Cause: Invalid schema migration deployed at 14:02 UTC.
        </p>
      </div>
    </div>



<div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl bg-white/20 dark:bg-black glass-gradient border border-gray/50 dark:border-white/20 p-6 flex flex-col justify-between shadow-glass transition-all duration-300 group">
      {/* Floating gradient circle */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200/20 dark:bg-cyan/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="p-1.5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
            <span className="material-symbols-outlined text-white text-sm">
              chat_bubble
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            Financial-Grade Predictive Modelling
          </h3>
        </div>
        <p className="text-gray-700 dark:text-gray-500 text-sm max-w-xl mb-4">
Move beyond basic trend extrapolation. Netraa’s advanced forecasting engine brings financial-level sophistication to your infrastructure planning. By incorporating daily, weekly, and monthly seasonality, historical anomaly behavior, and strict confidence intervals, you can identify risk zones and prevent resource exhaustion long before it happens.
        </p>
      </div>

      {/* Incident Box */}
      <div className="bg-gray-100/40 dark:bg-black rounded-xl p-3 border border-gray-200/30 dark:border-white/5 font-mono text-xs text-gray-700 dark:text-gray-300 relative">
        <div className="absolute top-2 right-2 flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
        </div>
        <p className="text-blue-500 dark:text-netraa-cyan mb-1">
          &gt; Initiating multi-factor predictive model for 'EU-Central-Cluster'...        </p>
        <p className="opacity-80">
Analyzing seasonal patterns, long-term trends, and historical anomaly behavior.
Forecast: 94% probability of CPU saturation next Thursday at 09:00 UTC.
        </p>
        <p className="text-orange-500 mt-1">
          Result: Risk zone highlighted. Recommend budget-aware capacity expansion.
        </p>
      </div>
    </div>


    <div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl bg-white/20 dark:bg-black glass-gradient border border-gray/50 dark:border-white/20 p-6 flex flex-col justify-between shadow-glass transition-all duration-300 group">
      {/* Floating gradient circle */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200/20 dark:bg-cyan/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

      {/* Content */}
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="p-1.5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg">
            <span className="material-symbols-outlined text-white text-sm">
              chat_bubble
            </span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            Deep Ticket Enrichment & Live Updates
          </h3>
        </div>
        <p className="text-gray-700 dark:text-gray-500 text-sm max-w-xl mb-4">
Transform your ITSM tickets from static alerts into living, real-time documents. Netraa seamlessly integrates with Jira, OTRS, and Slack, enriching every ticket with the exact symptoms, root cause, impacted components, and recommended remediations—continuously updating the ticket as system conditions evolve.
        </p>
      </div>

      {/* Incident Box */}
      <div className="bg-gray-100/40 dark:bg-black rounded-xl p-3 border border-gray-200/30 dark:border-white/5 font-mono text-xs text-gray-700 dark:text-gray-300 relative">
        <div className="absolute top-2 right-2 flex gap-1">
          <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
        </div>
        <p className="text-blue-500 dark:text-netraa-cyan mb-1">
          &gt; Orchestrating deep ITSM integration for new anomaly...        </p>
        <p className="opacity-80">
Creating ticket in Jira: Populating Severity, Symptoms, and Impacted Components.
Appending AI-generated recommended remediation plan.
        </p>
        <p className="text-orange-500 mt-1">
          System state changed: Auto-updating Jira ticket #OP-992 with new condition data.
        </p>
      </div>
    </div>
   
  </div>
</section>
</div>
);
}